import { ChangeEvent, memo, useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Selector.module.scss";
import { SelectorPropsI } from "./Selector.props";
import { useIntl } from "react-intl";
import { useLocale } from "@utils/hooks/useLocale";
import { LocaleLangE } from "../../../../i18n/LocaleContext";

function Selector({
  options,
  name,
  children,
  className,
  id,
  hasPrevValue,
  oldValue,
  reset,

  setSelected,
  onChangeValue,

  ...props
}: SelectorPropsI) {
  const { formatMessage } = useIntl();
  const { locale } = useLocale();
  const isRus = locale === LocaleLangE.RU;
  const [value, setValue_] = useState<string>(oldValue || options[0]);
  const [prevValue] = useState<string>(oldValue || options[0]);

  const setValue = (v: string) => {
    setValue_((was) => {
      was !== v && onChangeValue && onChangeValue();
      return v;
    });
  };

  const onChangeHandler = (e: ChangeEvent<HTMLSelectElement>) => {
    setSelected && setSelected(e.target.value);
    setValue(e.target.value);
  };

  useEffect(() => {
    if (!props.initial) return;
    setValue(props.initial || "");
  }, [props.initial]);

  useEffect(() => {
    if (!reset) return;
    setValue(options[0]);
  }, [reset]);

  return (
    <div className={cn(styles.wrapper, className)} tabIndex={-1} {...props}>
      <div className={styles.labels_wrapper}>
        {name && <label>{name}</label>}
      </div>
      <select onChange={onChangeHandler} id={id} value={value} tabIndex={-1}>
        {options.map((item, i) => (
          <option key={i} value={item}>
            {item === "All" ? (isRus ? "Все" : item) : item}
          </option>
        ))}
      </select>
      {hasPrevValue && prevValue !== value && (
        <p className={styles.oldValue}>
          {prevValue !== oldValue
            ? formatMessage({ id: "change_setting.prev" })
            : formatMessage({ id: "change_setting.current" })}
          <span>{prevValue}</span>
        </p>
      )}
    </div>
  );
}

export default memo(Selector);
